<template>
  <div :class="[
      'icon-container',
      `${ size }-icon`
  ]">
    <transition name="fade-opacity-lazy">
      <img :key="icon" :src="getUrlIcons(icon)" alt="icon">
    </transition>
  </div>
</template>

<script>
export default {
  name: "IconDefault",
  props: {
    icon: {
      type: String
    },
    size: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style scoped lang="scss">
  .icon-container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: var(--size-icon);
    width: 0;
    min-height: var(--size-icon);
    --active-padding: 0;
    height: 0;
    & img {
      width: calc(var(--size-icon) - 2 * var(--active-padding));
      height: calc(var(--size-icon) - 2 * var(--active-padding));
    }
  }
  @media (max-width: 3024px){
    .icon-container {
      &.big-icon {
        --size-icon: 56px;
      }
      &.default-icon {
        --size-icon: 28px;
        --active-padding: 2px;
      }
      &.small-icon {
        --size-icon: 20px;
      }
    }

  }

  @media (max-width: 1920px) {
    .icon-container {
      &.big-icon {
        --active-padding: 2px;
        --size-icon: 40px;
      }
      &.default-icon {
        --size-icon: 24px;
        --active-padding: 2px;
      }
      &.small-icon {
        --size-icon: 16px;
      }
    }
  }
  @media (max-width: 1600px) {
    .icon-container {
      &.big-icon {
        --active-padding: 1px;
        --size-icon: 32px;
      }
      &.default-icon {
        --size-icon: 20px;
        --active-padding: 1px;
        & img {
          width: calc(var(--size-icon) - 2 * var(--active-padding));
          height: calc(var(--size-icon) - 2 * var(--active-padding));
        }
      }
      &.small-icon {
        --size-icon: 16px;
      }
    }
  }
  @media (max-height: 800px) {
    .icon-container {
      &.big-icon {
        --active-padding: 1px;
        --size-icon: 32px;
      }
      &.default-icon {
        --size-icon: 16px;
        --active-padding: 0;
        & img {
          width: calc(var(--size-icon));
          height: calc(var(--size-icon));
        }
      }
      &.small-icon {
        --size-icon: 16px;
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .icon-container {
      &.big-icon {
        --active-padding: 1px;
        --size-icon: 32px;
      }
      &.default-icon {
        --size-icon: 20px;
        --active-padding: 1px;
        & img {
          width: calc(var(--size-icon) - 2 * var(--active-padding));
          height: calc(var(--size-icon) - 2 * var(--active-padding));
        }
      }
      &.small-icon {
        --size-icon: 16px;
      }
    }
  }

  @media (max-width: 1133px) {

    .icon-container {
      &.big-icon {
        --active-padding: 1px;
        --size-icon: 32px;
      }
      &.default-icon {
        --size-icon: 16px;
        --active-padding: 0;
        & img {
          width: calc(var(--size-icon));
          height: calc(var(--size-icon));
        }
      }
      &.small-icon {
        --size-icon: 16px;
      }
    }
  }
  @media (max-width: 769px) {
    .icon-container {
      &.big-icon {
        --active-padding: 0;
        --size-icon: 28px;
        & img {
          width: calc(var(--size-icon));
          height: calc(var(--size-icon));
        }
      }
      &.default-icon {
        --size-icon: 16px;
        --active-padding: 0;
      }
      &.small-icon {
        --size-icon: 12px;
      }
    }
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .icon-container {
      &.big-icon {
        --size-icon: 70px;
      }
      &.default-icon {
        --size-icon: 44px;
        --active-padding: 3px;
      }
      &.small-icon {
        --size-icon: 28px;
      }
    }
  }

</style>